import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { constantApp } from "../../../../config/constant";
class produce extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount = async () => {
    let url = `${constantApp.SERVERIP}:${constantApp.PORT_APPACHE}/PHP/Produce/Select_Produce.php`;
    let params = {
      LIMItcnt: 6,
    };
    let data = await axios
      .post(url, params)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {});

    // alert(JSON.stringify(url));
    // alert(JSON.stringify(data));
    // alert(JSON.stringify(data.length));

    if (data !== undefined && data.length > 0) {
      this.setState({ data: data });
    }
  };

  render() {
    return (
      <section className="contact-section   section-padding">
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-4">
              <div className="section-title-white">
                <h2>محصولات ما</h2>
              </div>
            </div>
            <div className="col col-lg-6 col-md-5">
              <p>
                پیشرفت در صنعت امروز مستلزم تمرکز بر انتخاب محصولات نوین و
                کارآمد در فضای رقابت است و این کار نیز تنها با در دست داشتن
                امکانات و ابزارهایی به روز ، کارآمد ، منعطف و ایمن میسر خواهد
                شد.
              </p>
            </div>
            <div className="col col-lg-3 col-md-3">
              <div className="all-service-link">
                <Link to="/produces" className="theme-btn">
                  همه محصولات
                </Link>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col col-xs-12">
              <div className="services-grids services-grid-view">
                {this.state.data.map((item) => {
                  return (
                    <div className="grid" key={item.idProduce}>
                      <div className="inner mk-bg-img">
                        <div className="details ">
                          <div className="info">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                `assets/images/produces/img-${item.idProduce}.jpg`
                              }
                              alt=""
                              role="presentation"
                              className="bg-image"
                            />
                            <Link
                              to={{
                                pathname: `produce/${item.idProduce}`,
                                state: { id: item.idProduce },
                              }}
                            >
                              <h3>
                                <i
                                  className="icon-apafan2ap"
                                  style={{ fontSize: "1.73em" }}
                                ></i>
                                {item.ProduceName}
                              </h3>
                            </Link>
                            <p>{item.Brief}</p>
                            <Link
                              to={{
                                pathname: `produce/${item.idProduce}`,
                                state: { id: item.idProduce },
                              }}
                              className="more"
                            >
                              دریافت جزئیات
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default produce;
